import $ from 'jquery'
import has from 'lodash/has'
import isBoolean from 'lodash/isBoolean'
import isString from 'lodash/isString'

import * as Model from 'api/model'

export default function PoziEdit () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziEdit().init Initialise events
     * @apiDescription Add events that monitor edit fields and update the underlying data.
     * @apiGroup Edit
     * @apiName init
     * @apiHeader (Model-On) {Function} Event app.event.drawer.tabs.info.data.editable.input.changed On event trigger data update.
     * @apiHeader (Model-On) {Function} Event app.event.drawer.tabs.info.data.editable.checkbox.changed On event trigger data update.
     */
    init: function () {
      return init()
    }
  }

  var init = function () {
    Model.on('app.event.drawer.tabs.info.data.editable.input.changed', _inputChanged)
    Model.on('app.event.drawer.tabs.info.data.editable.checkbox.changed', _checkboxChanged)
  }

  var _inputChanged = function (evt) {
    const sValue = $(evt.currentTarget).val()
    if (!isString(sValue)) {
      console.error('Input value must be a string.')
      return
    }
    const dataid = $(evt.currentTarget).attr('dataid') || ''
    if (!isString(dataid) || dataid === '') {
      console.error('Must provide a dataid.')
      return
    }
    _update(dataid, sValue)
  }

  var _checkboxChanged = function (evt) {
    const bValue = $(evt.currentTarget).is(':checked')
    if (!isBoolean(bValue)) {
      console.error('Input value must be a boolean.')
      return
    }
    const dataid = $(evt.currentTarget).attr('dataid') || ''
    if (!isString(dataid) || dataid === '') {
      console.error('Must provide a dataid.')
      return
    }
    _update(dataid, bValue)
  }

  var _update = function (propertieskey, value) {
    const geojson = Model.get('app.map.target.featurecollection', null)
    if (!has(geojson, 'features[0].properties.' + propertieskey)) {
      console.error('Cannot find propertieskey in app.map.target.featurecollection properties.')
      return
    }
    Model.set('app.map.target.featurecollection.features[0].properties.' + propertieskey, value)
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
